import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class ChannelTypeFilter extends Component {
    state = {
        channelTypeLists:[],
        channelTypeValue:null,
        channelTypeLoading: true
    };
    componentDidMount(){
        this.get_channel_type();
    }

    resetEmailFilter(){
        this.setState({
        channelTypeValue: [],
        })
    }
     get_channel_type(){
        axios.get(config.get('API_URL')+'/CampaignModule/get_campaign_channel_types/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((type, index) => {
                    this.state.channelTypeLists.push({value: type.channel_type_code, label: type.channel_type})
                });
            }
        });
     }
     changechannelType(optionSelected){
        let value='';
        let channelTypeArray = [];
        if(optionSelected.length < 1){
            value = null;
            channelTypeArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                channelTypeArray.push(mids.value)
                var index = this.state.channelTypeLists.findIndex(obj => obj.value==mids.value);
                this.state.channelTypeLists.move(index,0).join(',');

            });
        }
        this.props.onSelectChannelType(optionSelected,channelTypeArray);
        this.setState({
            channelTypeValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="product"
            isMulti
            value={this.state.channelTypeValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changechannelType.bind(this)}
            options={this.state.channelTypeLists}
            placeholderButtonLabel="Select [Channel]"
        />
        );

    }
}
export default ChannelTypeFilter;